import React from 'react'

const TableHead = () => {
    return (
        <thead className='d-none-mob'>
            <tr>
                <th />
                <th>Session name</th>
                <th>Session surname</th>
                <th>Number of sequences</th>
                <th>Created at</th>
                <th>Type</th>
                <th>Protocol</th>
                <th />
            </tr>
        </thead>
    )
}

export default TableHead
